import {Engine} from '@acng/frontend-stargazer';
import {media} from './env';
import {extend} from '@acng/frontend-bounty/object.js';
import {registerPurge} from 'acng/core/purge.js';

(() => {
  const name = 'ext';
  const ext = Engine.root.spawn(name);

  registerPurge(ext.template);

  ext.source = async ([name]) => {
    const module = await import(`${media.assets_ext}/resource/${name}/config.js`);
    const {getSource, getConfig} = module;
    const htmlFile = await getSource(Engine.rootScope);
    const config = extend(Engine.rootScope, await getConfig(Engine.rootScope));
    const resource = ext.spawn(name);
    resource.sourceScope = config;
    await resource.fetch(htmlFile, null);
  };
})();
